export const environment = import.meta.env.VITE_ENVIRONMENT;
export const baseUrl = import.meta.env.VITE_BASE_URL;

export const hostedDomain = import.meta.env.VITE_AWS_USERPOOL_HOSTED_DOMAIN;
export const userPoolId = import.meta.env.VITE_AWS_USERPOOL_ID;
export const clientId = import.meta.env.VITE_AWS_USERPOOL_APPCLIENT_ID;
export const region = import.meta.env.VITE_AWS_REGION;

export const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

export const enableFreeTrial =
  import.meta.env.VITE_ENABLE_FREE_TRIAL === "true";
